import React, { useState } from 'react';
import './VideoModel.css';

// You can replace this with a prop if you want a custom thumbnail
const defaultThumbnail = 'https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=800&q=80';

const VideoModal = ({ videoUrl, onClose, thumbnailUrl }) => {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="video-modal">
      <div className="video-modal-container">
        <button className="video-modal-closeBtn" onClick={onClose} aria-label="Close">&times;</button>
        <div className="video-modal-title">Shutter Tutorial</div>
        <hr className="video-modal-divider" />
        <div className="video-modal-videoWrapper">
          {playing ? (
            <iframe
              src={videoUrl}
              className="video-modal-video"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Tutorial Video"
            />
          ) : (
            <>
              <img
                src={thumbnailUrl || defaultThumbnail}
                alt="Video thumbnail"
                className="video-modal-thumbnail"
                onClick={() => setPlaying(true)}
              />
              <div className="video-modal-playButton" onClick={() => setPlaying(true)}>
                <div className="video-modal-playIcon" />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
